<template>
  <div>
    <el-dialog :visible.sync="show"  width="500px"  @close="closeDialog" @closed="clearCode" class="link_code" :showClose="showClose">
      <div class="code_box" v-if="this.$store.state.platformInfo.appId != '74web89ynsg'">
        <div id="qrcode" ref="qrcode" class="qrcode"></div>
        <div style="width: 280px;text-align: center;margin:6px auto;color: #000;">使用微信扫一扫，手机继续完成投递</div>
      </div>
       <div class="code_box" v-else>
        <div id="qrcode81" ref="qrcode81" class="qrcode" style="width:150px;height:150px"></div>
        <div style="width: 280px;text-align: center;margin:6px auto;color: #000;">使用微信扫一扫，手机继续完成投递</div>
          <div style="background-color: #ccc;text-align: right;font-size: 12px;">
        <ul style="list-style: inside;text-align: left;padding-inline-start: 40px;line-height: 1.5;padding-top: 15px;color: #000;">
          <li style="list-style: disc;">求职中如遇招聘方扣押证件、要求提供担保或收取财物、强迫入股或集资、收取不正当利益或其他违法情形，请立即举报。</li>
          <li style="list-style: disc;">如遇岗位要求海外工作，请提高警惕，谨防诈骗</li>
          <li style="list-style: disc;">81联聘禁止发布刷单、刷钻、优惠券推广类信息，求职者因从事此类工作造成经济损失，81联聘不承担任何责任！</li>
        </ul>
        <a href="/userprivacyagreement" target="_blank" style="color: #1f7ec3;text-decoration: underline;margin-right: 12px;"><span>查看详情</span></a>
      </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from "qrcodejs2"

export default {
  props: ['linkMask', 'linkInput'],
  data() {
    return {
      url:'',
      showClose:false
    }
  },
  computed: {
    show: {
      get() {
        return this.linkMask
      },
      set() {
        return this.linkMask
      }
    },
    link: {
      get() {
        return this.linkInput
      },
      set(val) {
        console.log('val', val)
      }
    }
  },
  created() {
    this.url = ''
    // 山东appId: 73x94y71svg      山西appId: app71rrf9ksr   81联聘：74web89ynsg     莲湖：75y7k29ehv  天津：2DW29x025k8  广东：GDs7Yz9HVP9Y
    if(this.$store.state.platformInfo.appId === '73x94y71svg'){
        this.url = 'https://sdh5.81lianpin.com/merge/jobDetail'
    }else if(this.$store.state.platformInfo.appId === 'app71rrf9ksr'){
       this.url = 'https://sjh5.81lianpin.com/merge/jobDetail'
     }else if(this.$store.state.platformInfo.appId === '74web89ynsg'){
       this.url = 'https://81h5.81lianpin.com/merge/jobDetail'
     }else if(this.$store.state.platformInfo.appId === '75y7k29ehv'){
       this.url = 'https://lhqh5.81lianpin.com/merge/jobDetail'
     }else if(this.$store.state.platformInfo.appId === '2DW29x025k8'){
      this.url = 'https://tjh5.81lianpin.com/merge/jobDetail'
    }else if(this.$store.state.platformInfo.appId === 'GDs7Yz9HVP9Y'){
      this.url = 'https://gdcjhh5.81lianpin.com/merge/jobDetail'
    }else{
      this.url = 'http://qah5.81lianpin.com/merge/jobDetail'
    }
  },
  methods: {
    //将连接转换成二维码
    qrcode(url) {
      this.$nextTick(() => {   //创建二维码必须在nextick之后  因为div未形成之前调用生成二维码会报错
        let qrcode = new QRCode(this.$refs.qrcode, {
          width: 280,
          height: 280,
          correctLevel: QRCode.CorrectLevel.L,//容错率，L/M/Q/H
          text: this.url+this.link +'&isshare=true'
        });
      })
    },
    qrcode81(url) {
      this.$nextTick(() => {   //创建二维码必须在nextick之后  因为div未形成之前调用生成二维码会报错
        let qrcode = new QRCode(this.$refs.qrcode81, {
          width: 150,
          height: 150,
          correctLevel: QRCode.CorrectLevel.L,//容错率，L/M/Q/H
          text: this.url+this.link +'&isshare=true'
        });
      })
    },
  
  //删除二维码
    clearCode() {
      if(this.$store.state.platformInfo.appId === '74web89ynsg'){
        this.$refs.qrcode81.innerHTML = "";
      }else{
        this.$refs.qrcode.innerHTML = "";
      }
     
    },
  
 
    closeDialog() {
      this.$emit('hidden')
    }
  }
}
</script>
<style scoped>
.link_code{
  text-align: center;
}
.qrcode{
  display: inline-block !important;
}
.qrcode81 img,.qrcode81 canvas{
  width: 150px !important;
  height: 150px !important;

}
</style>


// WEBPACK FOOTER //
// src/components/linkCode.vue